import { channelPartnerList, states, cities } from "constants/channelPartner";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const addChannelPartner = async (bodyData) => {
  try {
    const res = await api.add_channel_partner(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getChannelPartnerList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_channel_partner_list(pageNum, filters);
    dispatch({ type: channelPartnerList, payload: res?.data });
  } catch (error) {
    dispatch({
      type: channelPartnerList,
      payload: error?.response?.data || error,
    });
    authorizedUser(error.response?.data);
  }
};

export const getChannelPartnerById = async (id) => {
  try {
    const res = await api.get_channel_partner_by_id(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateChannelPartnerById = async (id, bodyData) => {
  try {
    const res = await api.update_channel_partner_by_id(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getStates = async (dispatch) => {
  try {
    const res = await api.state_list();
    dispatch({ type: states, payload: res.data });
  } catch (error) {
    dispatch({ type: states, payload: error?.response?.data || error });
    authorizedUser(error.response?.data);
  }
};

export const getCities = async (dispatch, filtersJSON) => {
  try {
    const res = await api.city_list(filtersJSON);
    dispatch({ type: cities, payload: res.data });
  } catch (error) {
    dispatch({ type: cities, payload: error?.response?.data || error });
    authorizedUser(error?.response?.data);
  }
};

export const addCity = async (bodyData) => {
  try {
    const res = await api.add_city(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error?.response?.data);
    return error?.response?.data || error;
  }
}